/* eslint-disable */

/**
 * Afterpay (Cash App Afterpay / Square) on-site messaging fix.
 *
 * The `<square-placement>` element that renders the Afterpay badge under the
 * product price is injected by the Afterpay app embed, not by the theme. When
 * the variant picker dispatches a `change` event on the instalments form, the
 * Afterpay SDK re-evaluates the placement and erroneously sets it to
 * `display: none` (even for eligible variants), so the badge disappears on
 * every variant switch.
 *
 * This script watches the product-price placement(s) and strips any
 * SDK-applied `display: none`, keeping the badge visible after variant changes.
 * The SDK still manages the displayed amount itself; we only correct visibility.
 * Scoped to `.product-info__price` so placements elsewhere (cart, collection
 * cards) are left untouched.
 */

(function () {
  const CONTAINER_SELECTOR = '.product-info__price';

  function unhide(placement) {
    if (placement.style.display === 'none') {
      placement.style.removeProperty('display');
    }
  }

  function attach(placement) {
    if (placement.dataset.afterpayFix === 'true') return;
    placement.dataset.afterpayFix = 'true';

    unhide(placement);

    const styleObserver = new MutationObserver(() => unhide(placement));
    styleObserver.observe(placement, {
      attributes: true,
      attributeFilter: ['style']
    });
  }

  function scan() {
    document
      .querySelectorAll(`${CONTAINER_SELECTOR} square-placement`)
      .forEach(attach);
  }

  function init() {
    scan();

    // The placement may be injected by the app embed after this script runs,
    // and may be re-created on variant change, so watch each price container.
    document.querySelectorAll(CONTAINER_SELECTOR).forEach((container) => {
      new MutationObserver(scan).observe(container, {
        childList: true,
        subtree: true
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
